var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 3.5C5.72451 3.5 5.50065 3.72386 5.50065 4C5.50065 4.27614 5.72451 4.5 6.00065 4.5H10.0007C10.2768 4.5 10.5007 4.27614 10.5007 4C10.5007 3.72386 10.2768 3.5 10.0007 3.5H6.00065Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 7.5C3.05784 7.5 2.83398 7.72386 2.83398 8C2.83398 8.27614 3.05784 8.5 3.33398 8.5H12.6673C12.9435 8.5 13.1673 8.27614 13.1673 8C13.1673 7.72386 12.9435 7.5 12.6673 7.5H3.33398Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 11.5C5.72451 11.5 5.50065 11.7239 5.50065 12C5.50065 12.2761 5.72451 12.5 6.00065 12.5H10.0007C10.2768 12.5 10.5007 12.2761 10.5007 12C10.5007 11.7239 10.2768 11.5 10.0007 11.5H6.00065Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/Filters.4cc606fc7eaec4f5f15bd14540b2fb88.svg";
export { ForwardRef as ReactComponent };